import { render, staticRenderFns } from "./StandappV2.vue?vue&type=template&id=14dc604c"
import script from "./StandappV2.vue?vue&type=script&lang=js"
export * from "./StandappV2.vue?vue&type=script&lang=js"
import style0 from "./StandappV2.vue?vue&type=style&index=0&id=14dc604c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports